// extracted by mini-css-extract-plugin
export default {"alert":"QSwZrAMxEAEE5BOXtacz","warning":"d4lvUiIG_krB3mQXaQJY","error":"UkBuLDvRAlypKcpxjKQ4","withClose":"L3I6cYOq3NZFeoRZkMfV","closeButton":"sEGDtGRlxmGbZA18ZaD4"};